export default "__VITE_ASSET__DHcYPdRJ__"